import React from "react";
import { Box, Chip } from "@mui/material";
import { theme } from "../../theme/colors";

/**
 * House / Senate / (optional) President sub-filters for FEC candidate browse.
 * Styling matches Discover location pills (primary fill when selected).
 */
export default function CandidateOfficeFilter({ options, value, onChange, compact = false }) {
  if (!options?.length) return null;

  return (
    <Box
      role="group"
      aria-label="Office"
      sx={{ display: "flex", gap: compact ? 0.75 : 1, flexWrap: "wrap", alignItems: "center" }}
    >
      {options.map((opt) => {
        const selected = value === opt.code;
        return (
          <Chip
            key={opt.code}
            label={opt.label}
            onClick={() => onChange(opt.code)}
            aria-pressed={selected}
            size={compact ? "small" : "medium"}
            sx={{
              fontWeight: 600,
              fontSize: compact ? 13 : 14,
              borderRadius: "8px",
              height: compact ? 32 : 36,
              bgcolor: selected ? theme.primary : "#fff",
              color: selected ? "#fff" : "#0f172a",
              border: selected ? "1px solid transparent" : "1px solid #e2e8f0",
              "&:hover": {
                bgcolor: selected ? (theme.primaryHover || "#065f46") : "#f8fafc",
              },
              "& .MuiChip-label": { px: compact ? 1.25 : 1.5 },
            }}
          />
        );
      })}
    </Box>
  );
}
